// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"3e08ee5c","363":"1748e5e8","504":"83fdb46f"}[chunkId] + ".chunk.css";
};